import React, { useEffect } from 'react';

function INSPACTLOCK() {
    useEffect(() => {
        // 1. Block keyboard shortcuts (DevTools, view-source, save, print) — both Win/Linux & Mac
        const handleKeyDown = (e) => {
            const k = (e.key || '').toLowerCase();
            const ctrl = e.ctrlKey || e.metaKey;
            const isBlocked =
                k === 'f12' ||
                (ctrl && e.shiftKey && ['i', 'j', 'c', 'k', 'e'].includes(k)) ||
                (ctrl && (k === 'u' || k === 's' || k === 'p')) ||
                (e.metaKey && e.altKey && ['i', 'j', 'c', 'u'].includes(k));
            if (isBlocked) {
                e.preventDefault();
                e.stopPropagation();
                return false;
            }
        };

        // 2. Block right-click, drag (image save), text selection (except inputs)
        const handleRightClick = (e) => { e.preventDefault(); return false; };
        const handleDragStart = (e) => { e.preventDefault(); return false; };
        const isEditable = (el) => {
            const t = el?.tagName;
            return t === 'INPUT' || t === 'TEXTAREA' || el?.isContentEditable;
        };
        const handleSelectStart = (e) => {
            if (isEditable(e.target)) return;
            e.preventDefault();
        };
        const handleCopy = (e) => {
            if (isEditable(e.target)) return;
            e.preventDefault();
        };

        document.addEventListener('keydown', handleKeyDown, true);
        document.addEventListener('contextmenu', handleRightClick, true);
        document.addEventListener('dragstart', handleDragStart, true);
        document.addEventListener('selectstart', handleSelectStart, true);
        document.addEventListener('copy', handleCopy, true);

        // 3. Inject CSS to disable selection + image dragging globally (inputs still selectable)
        const styleEl = document.createElement('style');
        styleEl.setAttribute('data-inspect-lock', '1');
        styleEl.innerHTML = `
            * {
                -webkit-user-select: none !important;
                -moz-user-select: none !important;
                -ms-user-select: none !important;
                user-select: none !important;
                -webkit-touch-callout: none !important;
            }
            input, textarea, [contenteditable="true"], [contenteditable=""] {
                -webkit-user-select: text !important;
                -moz-user-select: text !important;
                -ms-user-select: text !important;
                user-select: text !important;
            }
            img {
                -webkit-user-drag: none;
                -khtml-user-drag: none;
                -moz-user-drag: none;
                -o-user-drag: none;
                user-drag: none;
                pointer-events: auto;
            }
        `;
        document.head.appendChild(styleEl);

        // 4. Anti-iframe: break out of embedding (clickjacking + remote inspection vector)
        try {
            if (window.top !== window.self) {
                window.top.location.href = window.self.location.href;
            }
        } catch (_) {
            // cross-origin parent → just blank
            document.body.innerHTML = '';
        }

        // 5. Console silencer
        const clearLogId = setInterval(() => {
            try { console.clear(); } catch (_) { }
        }, 2000);

        // 6. Load disable-devtool library with stronger config (multi-engine detection)
        if (typeof window.__ddid === 'undefined') {
            window.__ddid = setTimeout(() => {
                const script = document.createElement('script');
                script.src = 'https://cdn.jsdelivr.net/npm/disable-devtool';
                script.setAttribute('disable-devtool-auto', '');
                script.setAttribute('disable-menu', 'true');
                script.setAttribute('clear-log', 'true');
                script.setAttribute('interval', '500');
                document.head.appendChild(script);
            }, 100);
        }

        return () => {
            document.removeEventListener('keydown', handleKeyDown, true);
            document.removeEventListener('contextmenu', handleRightClick, true);
            document.removeEventListener('dragstart', handleDragStart, true);
            document.removeEventListener('selectstart', handleSelectStart, true);
            document.removeEventListener('copy', handleCopy, true);
            clearInterval(clearLogId);
            if (styleEl.parentNode) styleEl.parentNode.removeChild(styleEl);
        };
    }, []);

    return null;
}

export default INSPACTLOCK;
